import { defineStore } from "pinia";
import { API_Authorization_login } from "@/services/api/Authorization/login";

export interface IAuthState {
  userAuthenticated: boolean;
  errorGettingUserData: boolean;
  loading: boolean;
}

export const useAuthStateStore = defineStore("authState", {
  state: (): IAuthState => {
    return {
      userAuthenticated: false,
      errorGettingUserData: false,
      loading: false,
    };
  },
  actions: {
    logIn({ login, passwd }: { login: string; passwd: string }) {
      return new Promise<void>((resolve, reject) => {
        this.loading = true;
        this.errorGettingUserData = false;

        API_Authorization_login({
          login,
          passwd,
        })
          .then(() => {
            this.userAuthenticated = true;
            resolve();
          })
          .catch(() => {
            this.userAuthenticated = false;
            this.errorGettingUserData = false;
            reject();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
});
